import { styled } from "@mui/material/styles"
import Box from "@mui/material/Box"
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress"
import { useAppSelector } from "../util/hooks"
import { PipelineStatusCodes } from "../util/interface"

export default function CustomizedProgressBar({
  percentage,
}: {
  percentage: number
}) {
  const green = "#27AF8D"
  const red = "rgb(226, 24, 36)"
  const gray = "gray"
  const executionStatus = useAppSelector(
    (store) =>
      store.monitor.pipelineRunDialog?.selectedRunDetails?.execution_status,
  )
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => {
    let color
    switch (executionStatus) {
      case PipelineStatusCodes.SUCCESS:
      case PipelineStatusCodes.RUNNING:
        color = green
        break
      case PipelineStatusCodes.SCHEDULED:
        color = gray
        break
      default:
        color = red
        break
    }

    return {
      height: 10,
      borderRadius: 5,
      [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor:
          theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
      },
      [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: color,
      },
    }
  })
  return (
    <Box sx={{ flexGrow: 1, width: 121 }}>
      <BorderLinearProgress variant="determinate" value={percentage} />
    </Box>
  )
}
